/**
 * 左键动画
 */
import fvAnimation from "./fvAnimation"
export default class fvLMousescript extends fvAnimation {
    constructor(shape){
        super(shape,"fvLmousescript");
        this.lmouseDownFunction = null;
        this.lmouseUpFunction = null;
        this.lmouseDbClickFunction = null;
        this.lmouseTimerUnitFunc = null;
        try{
          this.lmouseDownFunction = AsyncFunction(this.lmousedownscript);
          this.lmouseUpFunction = AsyncFunction(this.lmouseupscript);
          this.lmouseDbClickFunction = AsyncFunction(this.lmousedbscript);
          this.lmouseTimerUnitFunc = AsyncFunction(this.ltimerscript);
        }catch(e){
          console.error(e)
        }

        this.timer = null;
        this.timeOut = null;
        this.timeUp = null;
        this.lmouseTimerFunction = function(){
            clearTimeout(this.timeOut);
            this.executionScript(this.lmouseTimerUnitFunc);
            this.timer = setTimeout(this.lmouseTimerFunction,this.ltimer);
        }.bind(this);
        this.lastTime = 0;
        this.dbFirstFlag = true;
    }

   async run(event){
       await this.action(event);
    }

    async action(event){
        if("down" === this.getEventType(event.type)){
            var currTime = new Date().getTime();
            clearTimeout(this.timer);
            clearTimeout(this.timeOut);
            if(currTime - this.lastTime >= this.ltimer){
                this.lmouseTimerFunction();
            }

            // 鼠标点击小于300ms 双击
            if(currTime - this.lastTime < 300){
                clearTimeout(this.timeOut);
                clearTimeout(this.timeUp);
                this.executionScript(this.lmouseDbClickFunction);
            }else{
                clearTimeout(this.timeOut);
                clearTimeout(this.timeUp);
                this.timeOut = setTimeout(function() {
                    this.executionScript(this.lmouseDownFunction);
                }.bind(this),300);
            }
            this.lastTime = currTime;

        }else if("up" === this.getEventType(event.type)){
            // 鼠标抬起清楚周期执行
            clearTimeout(this.timer);
            this.timeUp = setTimeout(function() {
                this.executionScript(this.lmouseUpFunction);
            }.bind(this),300);
        }
    }

}



// WEBPACK FOOTER //
// ./src/js/div/animationDiv/fvLmousescript.js